import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import GaugeGraph from '../../components/gauge-graph';
import BarChart from '../../components/bar-chart';
import ScatterPlot from '../../components/scatter-plot';
import Sidebar from '../../components/sidebar';
import Fetch from '../../common/fetch';
import { Auth } from 'aws-amplify';
import './styles.css';




class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.fetch = new Fetch();
        this.state = {
            isLoaded: false,
            siteInfo: {}
        }
    }

    // load site info from backend database through querying
    async UNSAFE_componentWillMount() {
        const siteInfo = await this.getSiteInfo();
        this.setState({ isLoaded: true, siteInfo });
    }

    async getSiteInfo() {
        const user = await Auth.currentAuthenticatedUser();
        const { jwtToken } = user.signInUserSession.idToken;

        const url = 'https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/site/info';
        const options = {
            method: 'GET',
            headers: {
                authorization: jwtToken
            }
        };

        return await this.fetch.request(url, options);
    }




    render() {
        const { isLoaded } = this.state;
        // if page is not loaded, show empty page
        if (!isLoaded) {
            return (
                <div>
                    <Sidebar />
                    <div className='my-container' style={{ fontSize: '30px' }}></div>
                </div>
            );
        }
        else {
            return (
                <div>
                    <Sidebar />
                    <div className='container-fluid my-container'>
                        <div className='row' style={{ 'borderTop': '2px solid transparent' }}>
                            <div className='col my-col'>
                                <h5>Benchmark Score</h5>
                                {this.state.siteInfo.benchmark ? <GaugeGraph value={this.state.siteInfo.benchmark} append='canva1' className='myGauge' /> : <div style={{ width: '200px', height: '100px' }} />}
                                <ul>
                                    <li>Your property is more efficient than {this.state.siteInfo.benchmark} percent of all similar properties.</li>
                                    <li>The average benchmark score is 50.</li>
                                </ul>
                            </div>

                            <div className='col my-col'>
                                <h5>Top 3 Recommendations</h5>
                                <div className='container'>
                                    <div className='row '>
                                        <div className='col recommend grow'>
                                            <img src='/img/EnergyStarClothesWasher.jpg' className='recommendImg' alt='washer' />
                                            <p>Energy Star Clothes Washer</p>
                                        </div>
                                        <div className='col recommend grow'>
                                            <img src='/img/WindowFan.jpg' className='recommendImg' alt='windowfan' />
                                            <p>Window Fan</p>
                                        </div>
                                        <div className='col recommend grow'>
                                            <img src='/img/LEDLighting.jpg' className='recommendImg' alt='led' />
                                            <p>LED Lighting</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='row'>
                            <div className='col my-col'>
                                <h5>Comparison</h5>
                                <BarChart site={this.state.siteInfo.site} appendBar='canva2' />
                            </div>

                            <div className='col my-col'>
                                <h5>Temperature Profile</h5>
                                <ScatterPlot site={this.state.siteInfo.site} appendPlot='canva3' />
                            </div>
                        </div>


                        <div className='row' >
                            <div className='col my-col'>
                                <strong>Property ID: </strong>{this.state.siteInfo.site}<br />

                                <strong>Site Address:</strong><br />
                                {this.state.siteInfo.address}<br />

                                <strong>Property Type: </strong>Single Family<br /><br />

                                <strong>Building Foor Area(Sq. Ft): </strong>{this.state.siteInfo.area}<br />
                                <strong>Units: </strong>{this.state.siteInfo.units}<br />
                                <strong>Year Built: </strong>{this.state.siteInfo.year_blt}<br />
                                <strong>Pool: </strong>{this.state.siteInfo.pool}<br />
                            </div>
                            <div className='col my-col'>
                                <b>Owner: </b>{this.state.siteInfo.owner}<br />
                                <b>Mailing Address: </b><br />
                                {this.state.siteInfo.owner_address}<br /><br />

                                <b>Electric Heating: </b>{this.state.siteInfo.temp_profile}<br />
                                <b>Tenant Meters: </b> {this.state.siteInfo.res_meters}<br />
                                <b>Common Area Meters: </b>{this.state.siteInfo.non_res_meters}<br />
                                <b>Master Metered: </b>{this.state.siteInfo.master_m}<br />
                            </div>
                            <div className='col my-col'>
                                <h5>Data Quality</h5>
                                <p><b>Property Type Confidence: </b></p>
                                <div className='circleGlow glowRed grow' />

                                <p><strong>Property Attribute Aggregation Confidence: </strong><br /></p>
                                <div className='circleGlow glowGreen grow' />

                            </div>
                        </div>
                    </div>
                </div>
            );
        }

    } // render
}

export default withRouter(Dashboard);


// WEBPACK FOOTER //
// ./src/routes/dashboard/index.js